import { createContext, useContext, ReactNode, useState, useMemo } from 'react';

// Create a context to allow pages to set their own headers
interface HeaderContextType {
  headerText?: string | ReactNode;
  menuActions?: ReactNode;
  setHeaderText: (text: string | ReactNode) => void;
  setMenuActions: (actions: ReactNode) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};

interface HeaderProviderProps {
  children: ReactNode;
}

export const HeaderProvider = ({ children }: HeaderProviderProps) => {
  const [headerText, setHeaderText] = useState<string | ReactNode>('Dashboard');
  const [menuActions, setMenuActions] = useState<ReactNode>(null);

  const value = useMemo(() => ({
    headerText,
    menuActions,
    setHeaderText,
    setMenuActions
  }), [headerText, menuActions]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};
